import { DialogComponent } from "@theme/dialog";

export class RequestProductDialog extends DialogComponent {
  constructor() {
    super();
  }
  // @ts-ignore
  showDialog(variantId, quantity, productTitle) {
    super.showDialog();

    this.variantId = variantId;
    this.quantity = quantity;

    this.quoteContent = this.querySelector("#quote-content");
    this.heading = this.querySelector("#popup-dialog-heading");

    if (this.quoteContent) {
      // @ts-ignore
      this.quoteContent.style.display = "block";
    }
    if (this.heading) {
      // @ts-ignore
      this.heading.textContent = productTitle || "";
      // @ts-ignore
      this.heading.style.display = "block";
    }

    this.btn = this.querySelector("#submit-draft-order");
    this.msgContainer = this.querySelector("#quote-message-container");
  }

  /**
   * Handles the click event for the add to cart button.
   * @param {MouseEvent & {target: HTMLElement}} event - The click event.
   */
  handleSubmitThisItem(event) {
    event.preventDefault();

    // @ts-ignore
    if (requestUnavailableProduct) {
      // @ts-ignore
      requestUnavailableProduct.call(this);
    }
  }

  /**
   * Handles the click event for the add to cart button.
   * @param {MouseEvent & {target: HTMLElement}} event - The click event.
   */
  closePopup(event) {
    event.preventDefault();
    this.closeDialog();
  }

  async closeDialog() {
    super.closeDialog();

    if (this.msgContainer) {
      this.msgContainer.textContent = "";
      // @ts-ignore
      this.msgContainer.style.display = "none";
    }
  }
}

if (!customElements.get("request-dialog-product"))
  customElements.define("request-dialog-product", RequestProductDialog);
